import { query, mutation } from '@/dex-shared/helpers/graphql';
import exams from './exams';

export default {
  state: {
    examGroups: [],
    examGroup: null,
    exams: [],
    examGroupForReference: null,
  },
  getters: {
    currentExamGroup: (state: any) => {
      if (state.examGroup) {
        let materials = [];
        if (state.examGroup.materialsByExamGroupId) {
          materials = state.examGroup.materialsByExamGroupId.nodes;
        }
        let exams = [];
        if (state.examGroup.examGroupsExamsByExamGroupId) {
          exams = state.examGroup.examGroupsExamsByExamGroupId.nodes;
        }

        let boards: any[] = [];
        let boardSections: any[] = [];
        let boardSubsections: any[] = [];
        let examGroupExams: any[] = [];
        if (materials) {
          materials.forEach((material: any) => {
            if (material.boardByBoardId) {
              material.boardByBoardId.materialId = material.id;
              boards.push(material.boardByBoardId);
            }
            if (material.boardSectionByBoardSectionsId) {
              material.boardSectionByBoardSectionsId.materialId = material.id;
              boardSections.push(material.boardSectionByBoardSectionsId);
            }
            if (material.boardSubsectionByBoardSubsectionsId) {
              material.boardSubsectionByBoardSubsectionsId.materialId =
                material.id;
              boardSubsections.push(
                material.boardSubsectionByBoardSubsectionsId,
              );
            }
          });
        }
        return {
          id: state.examGroup.id,
          name: state.examGroup.name,
          slug: state.examGroup.slug,
          payerOnly: !!state.examGroup.payerOnly,
          boards: boards,
          boardSections: boardSections,
          boardSubsections: boardSubsections,
          exams: exams.filter(e => !!e).map(e => e.examByExamId),
          allowedEmails: (state.examGroup.allowedEmails || []).join(','),
          examDate: state.examGroup.examDate,
        };
      }
      return {};
    },
    currentExamGroupForReference: (state: any) => {
      if (state.examGroupForReference) {
        let materials = [];
        if (state.examGroupForReference.materialsByExamGroupId) {
          materials = state.examGroupForReference.materialsByExamGroupId.nodes;
        }
        let exams = [];
        if (state.examGroupForReference.examGroupsExamsByExamGroupId) {
          exams =
            state.examGroupForReference.examGroupsExamsByExamGroupId.nodes;
        }

        let boards: any[] = [];
        let boardSections: any[] = [];
        let boardSubsections: any[] = [];
        let examGroupExams: any[] = [];
        if (materials) {
          materials.forEach((material: any) => {
            if (material.boardByBoardId) {
              material.boardByBoardId.materialId = material.id;
              boards.push(material.boardByBoardId);
            }
            if (material.boardSectionByBoardSectionsId) {
              material.boardSectionByBoardSectionsId.materialId = material.id;
              boardSections.push(material.boardSectionByBoardSectionsId);
            }
            if (material.boardSubsectionByBoardSubsectionsId) {
              material.boardSubsectionByBoardSubsectionsId.materialId =
                material.id;
              boardSubsections.push(
                material.boardSubsectionByBoardSubsectionsId,
              );
            }
          });
        }
        return {
          id: state.examGroupForReference.id,
          name: state.examGroupForReference.name,
          slug: state.examGroupForReference.slug,
          payerOnly: !!state.examGroupForReference.payerOnly,
          boards: boards,
          boardSections: boardSections,
          boardSubsections: boardSubsections,
          exams: exams.filter(e => !!e).map(e => e.examByExamId),
          allowedEmails: (state.examGroupForReference.allowedEmails || []).join(
            ',',
          ),
          examDate: state.examGroup.examDate,
        };
      } else {
        return {};
      }
    },
    currentExamGroupExams: (state: any) => {
      if (state.examGroup && state.examGroup.examGroupsExamsByExamGroupId) {
        let exams = state.examGroup.examGroupsExamsByExamGroupId.nodes.map(
          (examNode: any) => {
            let exam = examNode.examByExamId;
            return {
              id: exam.id,
              name: exam.name,
              duration: exam.duration,
              questionsNumber: exam.examQuestionsByExamId.totalCount,
              examDate: state.examDate,
            };
          },
        );
        return exams;
      }
      return [];
    },
  },
  mutations: {
    SET_EXAM_GROUP(state: any, examGroup: any) {
      state.examGroup = examGroup;
    },
    SET_EXAM_GROUP_FOR_REFERENCE(state: any, examGroup: any) {
      state.examGroupForReference = examGroup;
    },
    SET_EXAM_GROUPS(state: any, examGroups: any) {
      state.examGroups = examGroups.map((examGroup: any) => {
        examGroup.examsCount =
          examGroup.examGroupsExamsByExamGroupId.totalCount;

        let boards: any[] = [];
        let materials = examGroup.materialsByExamGroupId.nodes;

        if (materials.length > 0) {
          materials.forEach((material: any) => {
            if (material.boardByBoardId) {
              material.boardByBoardId.materialId = material.id;
              boards.push(material.boardByBoardId);
            }
          });
        }

        examGroup.boards = boards;
        return examGroup;
      });
    },
    SET_EMPTY_EXAM_GROUP(state: any) {
      let examGroup = {
        id: null,
        name: null,
        description: null,
        examDate: null,
        exams: [],
        payerOnly: false,
      };
      state.examGroup = examGroup;
    },
  },
  actions: {
    async PUSH_EXAM_GROUP({ commit, state, rootState }: any, examGroup: any) {
      let userId = rootState.auth.user ? rootState.auth.user.id : null;
      let response;
      let examGroupResponse;
      let exams = examGroup.exams;
      let allowedEmails = null;

      if (examGroup.allowedEmails) {
        const emails = examGroup.allowedEmails
          .split(',')
          .reduce((acc, email) => {
            if (email.trim()) acc.push(email.trim());

            return acc;
          }, []);

        allowedEmails = emails.length > 0 ? emails : null;
      }

      if (examGroup.id != null) {
        //update
        response = await mutation(
          `mutation updateExamGroup (
            $examGroupId: Int!,
            $name: String!,
            $description: String!,
            $payerOnly: Boolean!,
            $allowedEmails: JSON
            $examDate: Datetime
          ) {
            updateExamGroupById(
              input:
                {id: $examGroupId,
                  examGroupPatch:
                  {
                    name: $name,
                    description: $description,
                    payerOnly: $payerOnly,
                    allowedEmails: $allowedEmails,
                    examDate: $examDate,
                  }
                }
            )
            {
              examGroup {
                id
              }
            }
          }`,
          {
            examGroupId: examGroup.id,
            name: examGroup.name,
            description: examGroup.description || '',
            payerOnly: !!examGroup.payerOnly,
            allowedEmails,
            examDate: examGroup.examDate,
          },
        );

        let examGroupsExamsResponse = await query(
          `
            query ExamGroupExamsIds($examGroupId: Int!) {
              allExamGroupsExams(condition: {
                examGroupId: $examGroupId
              }) {
                nodes {
                  id
                }
              }
            }
          `,
          { examGroupId: examGroup.id },
        );
        const ids = examGroupsExamsResponse.data.allExamGroupsExams.nodes.map(
          n => n.id,
        );

        if (ids.length) {
          await Promise.all(
            ids.map(id =>
              mutation(
                `
              mutation DeleteExamGroupsExam($id: Int!) {
                deleteExamGroupsExamById(input: {
                  id: $id
                }) {
                  examGroupsExam {
                    id
                  }
                }
              }
            `,
                { id },
              ),
            ),
          );
        }

        await Promise.all(
          exams.map(examId =>
            mutation(
              `
              mutation CreateExamGroupsExam($examGroupId: Int!, $userId: Int!, $examId: Int!) {
                createExamGroupsExam(
                  input: {
                    examGroupsExam: {
                      examGroupId: $examGroupId,
                      examId: $examId,
                      userId: $userId
                    }
                  }
                ) {
                  examGroupsExam {
                    id
                    examGroupId
                    examId
                  }
                }
              }
            `,
              {
                examGroupId: +examGroup.id,
                userId,
                examId,
              },
            ),
          ),
        );

        response = await query(
          `
            query pullExamGroup($examGroupId: Int!) {
              examGroupById(id: $examGroupId) {
                id
                name
                slug
                description
                userId
                payerOnly
                allowedEmails
                examDate
                examGroupsExamsByExamGroupId(orderBy: EXAM_BY_EXAM_ID__START_ASC) {
                  totalCount
                  nodes {
                    examByExamId {
                      id
                      name
                      slug
                      start
                      duration
                      description
                      examQuestionsByExamId{
                        totalCount
                      }
                    }
                  }
                }
              }
            }
          `,
          { examGroupId: +examGroup.id },
        );

        examGroupResponse = response.data.examGroupById;
      } else {
        //create
        response = await mutation(
          `mutation createExamGroup ($userId: Int!, $name: String!, $description: String!, $payerOnly: Boolean!, $allowedEmails: JSON, $examDate: Datetime) {
            createExamGroup(
              input:
                {examGroup:
                  {
                    userId: $userId,
                    name: $name,
                    description: $description,
                    payerOnly: $payerOnly,
                    allowedEmails: $allowedEmails,
                    examDate: $examDate,
                  }
                }
            )
            {
              examGroup {
                id
                name
                description
                examDate
                userId
                payerOnly
                allowedEmails
                examGroupsExamsByExamGroupId(orderBy: EXAM_BY_EXAM_ID__START_ASC) {
                  totalCount
                  nodes {
                    examByExamId {
                      id
                      name
                      slug
                      start
                      duration
                      description
                      examQuestionsByExamId{
                        totalCount
                      }
                    }
                  }
                }
              }
            }
          }`,
          {
            userId: userId,
            name: examGroup.name,
            description: examGroup.description || '',
            payerOnly: !!examGroup.payerOnly,
            allowedEmails,
            examDate: examGroup.examDate,
          },
        );

        examGroupResponse = response.data.createExamGroup.examGroup;

        if (examGroupResponse.id) {
          await Promise.all(
            exams.map(examId =>
              mutation(
                `
                mutation CreateExamGroupsExam($examGroupId: Int!, $userId: Int!, $examId: Int!) {
                  createExamGroupsExam(
                    input: {
                      examGroupsExam: {
                        examGroupId: $examGroupId,
                        examId: $examId,
                        userId: $userId
                      }
                    }
                  ) {
                    examGroupsExam {
                      id
                      examGroupId
                      examId
                    }
                  }
                }
              `,
                {
                  examGroupId: +examGroupResponse.id,
                  userId,
                  examId,
                },
              ),
            ),
          );
        }

        response = await query(
          `
            query pullExamGroup($examGroupId: Int!) {
              examGroupById(id: $examGroupId) {
                id
                name
                slug
                description
                userId
                payerOnly
                allowedEmails
                examDate
                examGroupsExamsByExamGroupId(orderBy: EXAM_BY_EXAM_ID__START_ASC) {
                  totalCount
                  nodes {
                    examByExamId {
                      id
                      name
                      slug
                      start
                      duration
                      description
                      examQuestionsByExamId{
                        totalCount
                      }
                    }
                  }
                }
              }
            }
          `,
          { examGroupId: +examGroupResponse.id },
        );

        examGroupResponse = response.data.examGroupById;
      }

      if (examGroupResponse != null) {
        commit('SET_EXAM_GROUP', examGroupResponse);
      }
    },
    async PUSH_EXAM_GROUP_WITH_REFERENCE(
      { commit, state, rootState }: any,
      { examGroup, examGroupReference }: any,
    ) {
      const newExamGroupName = examGroup.name;
      const examsToBeMirrored = examGroupReference.exams.map(exam => ({
        id: exam.id,
        start: exam.start,
        end: exam.end,
      }));
      const response = await mutation(
        `
        mutation CreateExamGroupWithReference($newExamGroupName: String!, $examsToBeMirrored: [JSON!]) {
          createExamGroupWithReference(newExamGroupName: $newExamGroupName, examsToBeMirrored: $examsToBeMirrored) {
            id
            name
            description
            userId
          }
        }
      `,
        {
          newExamGroupName,
          examsToBeMirrored,
        },
      );
      commit('SET_EXAM_GROUP', response.data.createExamGroupWithReference);
    },
    async PULL_EXAM_GROUP(
      { commit, state, rootState }: any,
      examGroupId: number,
    ) {
      let user = rootState.auth.user;
      let response = await query(`query getExamGroupByIdDexAdmin{
              examGroupById(id: ${examGroupId}){
                  id
                  name
                  slug
                  payerOnly
                  allowedEmails
                  examDate
                  examGroupsExamsByExamGroupId(orderBy: [EXAM_BY_EXAM_ID__START_ASC, POSITION_ASC]){
                    nodes{
                      examByExamId{
                        id
                        name
                        slug
                        duration
                        description
                        start
                        end
                        examQuestionsByExamId{
                          totalCount
                        }
                      }
                    }
                  }
                  materialsByExamGroupId {
                    nodes {
                      id
                      boardByBoardId {
                        id
                        title
                      }
                      boardSectionByBoardSectionsId {
                        id
                        title
                      }
                      boardSubsectionByBoardSubsectionsId {
                        id
                        title
                      }
                    }
                  }
                }
            }`);
      commit('SET_EXAM_GROUP', response.data.examGroupById);
    },
    async PULL_EXAM_GROUP_FOR_REFERENCE(
      { commit, state, rootState }: any,
      examGroupId: number,
    ) {
      let user = rootState.auth.user;
      let response = await query(`query getExamGroupForReferenceDexAdmin{
              examGroupById(id: ${examGroupId}){
                  id
                  name
                  slug
                  payerOnly
                  allowedEmails
                  examDate
                  examGroupsExamsByExamGroupId(orderBy: [EXAM_BY_EXAM_ID__START_ASC, POSITION_ASC]){
                    nodes{
                      examByExamId{
                        id
                        name
                        slug
                        start
                        duration
                        description
                        examQuestionsByExamId{
                          totalCount
                        }
                      }
                    }
                  }
                  materialsByExamGroupId {
                    nodes {
                      id
                      boardByBoardId {
                        id
                        title
                      }
                      boardSectionByBoardSectionsId {
                        id
                        title
                      }
                      boardSubsectionByBoardSubsectionsId {
                        id
                        title
                      }
                    }
                  }
                }
            }`);
      commit('SET_EXAM_GROUP_FOR_REFERENCE', response.data.examGroupById);
    },
  },
};
